// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"56":"6402e59e","394":"bb6e0a0d","707":"4f034e44","760":"3c80cde3","919":"4fdc4371","945":"3f7ae47c"}[chunkId] + ".css";
};